/**
 * Shared field-level validation helpers.
 * Used across all forms to enforce consistent rules.
 */

/**
 * Validate a phone number: 10 digits, or 11 if the first digit is 1 (country code).
 * Returns an error message string, or null if valid.
 * Passing empty/undefined is always valid (handle required checks separately).
 */
export function validatePhone(value: string | undefined): string | null {
    if (!value || !value.trim()) return null;
    const digits = value.replace(/\D/g, '');
    if (digits.length < 10) return 'Phone must be at least 10 digits';
    if (digits.length === 11 && digits[0] !== '1') return 'An 11-digit number must start with country code 1';
    if (digits.length > 11) return 'Phone number is too long';
    return null;
}

/**
 * Validate postal/ZIP code based on country.
 * Returns an error message string, or null if valid.
 */
export function validatePostalCode(value: string, country: string): string | null {
    if (!value || !value.trim()) return null;
    const v = value.trim();

    if (country === 'Canada') {
        // Canadian postal code: A1A 1A1 or A1A1A1
        if (!/^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/.test(v)) {
            return 'Enter a valid Canadian postal code (e.g. V2S 1A5)';
        }
    } else if (country === 'USA') {
        // US ZIP: 5 digits or ZIP+4
        if (!/^\d{5}(-\d{4})?$/.test(v)) {
            return 'Enter a valid ZIP code (e.g. 90210 or 90210-1234)';
        }
    }
    // Mexico and other: no specific format enforced beyond min length
    return null;
}
